import { Link } from "react-router-dom";
import { Clock, Coins, User, MapPin, Users } from "lucide-react";
import { CATEGORY_LABELS, formatDate } from "@/lib/data";

export function SessionCard({ session, index = 0 }) {
  const spotsLeft = session.capacity - session.booked_count;
  return (
    <Link
      to={`/seans/${session.id}`}
      data-testid={`session-card-${session.id}`}
      className="group block animate-fade-up rounded-2xl border border-[#E5E0D8] bg-white p-5 transition-all hover:border-[#8C6A5D] hover:shadow-[0_8px_30px_-14px_rgba(140,106,93,0.5)]"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <span className="text-xs font-medium uppercase tracking-wide text-[#8C6A5D]">
            {CATEGORY_LABELS[session.category]}
          </span>
          <h3 className="mt-1 font-display text-lg font-semibold leading-tight">{session.title}</h3>
          <p className="mt-0.5 text-sm text-[#5C5856]">{session.studio_name}</p>
        </div>
        {session.is_last_minute && (
          <span className="shrink-0 rounded-full bg-[#4A5D4E] px-2.5 py-1 text-xs font-medium text-white">
            Son Dakika
          </span>
        )}
      </div>

      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1.5 text-sm text-[#5C5856]">
        <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {formatDate(session.date)} · {session.start_time}</span>
        <span className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" /> {session.instructor}</span>
        <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {session.region}</span>
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-[#F0EAE0] pt-4">
        <span className="flex items-center gap-1.5 text-sm text-[#5C5856]">
          <Users className="h-3.5 w-3.5" /> {spotsLeft > 0 ? `${spotsLeft} yer kaldı` : "Dolu"}
        </span>
        <div className="flex items-center gap-2">
          {session.original_price && (
            <span className="text-sm text-[#B0A79A] line-through">{session.original_price}</span>
          )}
          <span className="flex items-center gap-1 font-semibold text-[#8C6A5D]">
            <Coins className="h-4 w-4" /> {session.credit_price}
          </span>
        </div>
      </div>
    </Link>
  );
}
